import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { compose } from "recompose";

const languageOption = (locale, options) => {
    return options.filter(item => item.slug === locale)[0];
}
const SvgIcon = styled.svg`
    width: 30px;
    height: 20px;
    max-width: 100%;
`;

const FlagSprite = styled.div`
    display: none;
    width:0px;
    height:0px;
`;
const LSInner = styled.div`
    height:38px;
`;
const LSInnerA = styled.a`
width: 30px; 
height: 20px;
`;
const LSInnerImg = styled.img`
    width: 30px; 
    height: 20px;

    @media (max-width:767px){
        width: 50px; 
    }
`;
const LSContainer = styled.div`
    z-index:200;
    position: absolute;
    right: 0;
    top: 30px;
    border-radius: 3px;
    width: 500px;
    padding: 15px;

    @media (max-width:767px){
        margin-top: 40px;
        position: relative;
    }
`;

const LSli = styled.div`
    display: inline-block;
    width: calc(50% - 2px);
    
    &:hover{
        background:${colors.grey3};
    }
    
    @media (max-width:767px){
        padding : 0 0 10px 0;
    }
`;

const LSa = styled.a`
    display: flex;
    align-items: center;
    text-decoration:none;
    color: ${colors.blue1};
    padding: 10px;
    border: 1px solid transparent;
    border-radius:3px;
    
    &:hover {
        background: rgba(255,255,255,.5);
    }
`;

const LSimg = styled.img`
    width: 30px; 
    height: auto;
    margin-right:15px;
    
    @media (max-width:767px){
        width: 30px; 
    }
`;

const LStitle = styled.div`
    color: ${colors.blue1};
    font-weight:bold;
    margin-bottom:15px;
`;

const LSselect = styled.select`
    font-size:1em;
    color: white;
    background-color: transparent;
    border: 0px solid transparent;
    line-height: 1.4em;
`;

let aselectedstyle = {
    display:'none'
};

class LanguageSelectorComponent  extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            open: false
        };
    }

    lpLanguageOptions = (locale, options, mobile) => {
        if (mobile) {
             return options.map((item, key) =>
                 <option key={key} value={key} >{item.title}</option>
             );
        }

        return options.map((item, key) =>
            <LSli key={key} style={item.slug === locale ? aselectedstyle : {}}>
                <LSa title={(typeof item.metaTitle !== 'undefined' && item.metaTitle !== '' )? item.metaTitle : item.title} href={item.url}>
                    <SvgIcon className="mr-3" dangerouslySetInnerHTML={{__html: '<use xlink:href="#flag-' + item.slug + '"></use>' }} alt={item.title}  />{item.title}
                </LSa>
            </LSli>
        );
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    setWrapperRef = node => {
        this.wrapperRef = node;
    };
    
    handleClickOutside = event => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ open: false });
        }
    };
    getGaUrl = (url) => {
        if (typeof ga === "function" && ga.getAll().length > 0 ) {
            var linkerParam = ga.getAll()[0].get("linkerParam");
            var linkerParamValue = linkerParam.split("=")[1];
            url = url + '?_ga=' + linkerParamValue;
        }
        return url
    }
    selectLanguage = (event, type) => {
        switch(type) {
            case 'landing':
                var options = this.props.landingPagesIntl;
                window.location.href = this.getGaUrl(options[event.target.value].url);
                break;
            case 'ai_landing':
                var options = this.props.aiLandingpagesIntl;
                window.location.href = this.getGaUrl(options[event.target.value].url);
                break;
            default:
                var options = this.props.languageSelectorOptions;
                window.location.href = this.getGaUrl(options[event.target.value].url);
        }
    }

    toggle = (e) => {
        e.preventDefault();
        if (this.props.landingPagesIntl.length > 1 || this.props.languageSelectorOptions.length > 1 || this.props.aiLandingpagesIntl.length > 1) {
            this.setState(state => ({ open: !state.open }));
        }
    };
    
    flagSprite = () => { 
        return <FlagSprite dangerouslySetInnerHTML={{ __html: '<svg width="0" height="0" class="hidden"> <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 15000 10000" id="flag-be"> <defs> <path id="a" d="M13749 9750H1249c-550 0-1000-450-1000-1000V1250c0-550 450-1000 1000-1000h12500c550 0 1000 450 1000 1000v7500c0 550-450 1000-1000 1000z"></path> </defs> <clipPath id="b"> <use xlink:href="#a" overflow="visible"></use> </clipPath> <path clip-path="url(#b)" stroke="#FFF" stroke-miterlimit="10" d="M250 250h5000v9500H250z"></path> <g> <defs> <path id="c" d="M13749 9750H1249c-550 0-1000-450-1000-1000V1250c0-550 450-1000 1000-1000h12500c550 0 1000 450 1000 1000v7500c0 550-450 1000-1000 1000z"></path> </defs> <clipPath id="d"> <use xlink:href="#c" overflow="visible"></use> </clipPath> <path clip-path="url(#d)" fill="#FFE936" stroke="#FFF" stroke-miterlimit="10" d="M5250 250h4500v9500H5250z"></path> </g> <g> <defs> <path id="e" d="M13749 9750H1249c-550 0-1000-450-1000-1000V1250c0-550 450-1000 1000-1000h12500c550 0 1000 450 1000 1000v7500c0 550-450 1000-1000 1000z"></path> </defs> <clipPath id="f"> <use xlink:href="#e" overflow="visible"></use> </clipPath> <path clip-path="url(#f)" fill="#FF0F21" stroke="#FFF" stroke-miterlimit="10" d="M9750 250h5000v9500H9750z"></path> </g> </symbol> <symbol xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 220 150" id="flag-ca_es"> <rect height="150" width="220" rx="16" ry="16" fill-rule="evenodd" fill="#fcdd09"></rect> <path fill-rule="evenodd" fill="#d90700" d="M0 16.6h220v16H0zM0 50h220v16H0zM0 83.2h220v16H0zM0 116.6h220v16H0z"></path> </symbol> <symbol version="1.1" id="flag-da" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <path fill="#F1253C" d="M20.1,0.1H8.5v6.2H22V2C22,1,21.2,0.1,20.1,0.1z"></path> </g> <g> <path fill="#F1253C" d="M8.5,14.9h11.6c1,0,1.9-0.8,1.9-1.9V8.6H8.5V14.9z"></path> </g> <g> <path fill="#F1253C" d="M0,8.6V13c0,1,0.8,1.9,1.9,1.9h4.4V8.6H0z"></path> </g> <g> <path fill="#F1253C" d="M6.3,0.1H1.9C0.8,0.1,0,1,0,2v4.4h6.3V0.1z"></path> </g> <g> <polygon fill="#F9F9F9" points="8.5,6.4 8.5,0.1 6.3,0.1 6.3,6.4 0,6.4 0,8.6 6.3,8.6 6.3,14.9 8.5,14.9 8.5,8.6 22,8.6 22,6.4 "></polygon> </g> </g> </symbol> <symbol version="1.1" id="flag-de" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <path fill="#0A0A0A" d="M20.1,0.1H1.9C0.8,0.1,0,1,0,2v3h22V2C22,1,21.2,0.1,20.1,0.1z"></path> </g> <g> <rect y="5" fill="#FD282F" width="22" height="4.9"></rect> </g> <g> <path fill="#FFD703" d="M0,13c0,1,0.8,1.9,1.9,1.9h18.3c1,0,1.9-0.8,1.9-1.9v-3H0V13z"></path> </g> </g> </symbol> <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22 15" id="flag-en"> <g> <g> <path fill="#1A3179" d="M12.8 14.9h6.5l-6.5-4.5z"></path> </g> <g> <path fill="#1A3179" d="M0 9.9v3.4L5 10l-5-.1z"></path> </g> <g> <path fill="#1A3179" d="M0 1.7V4.9l4.9.1L0 1.7z"></path> </g> <g> <path fill="#1A3179" d="M19.5.1h-6.7v4.6z"></path> </g> <g> <path fill="#1A3179" d="M22 4.9V2v-.3L17.1 5l4.9-.1z"></path> </g> <g> <path fill="#1A3179" d="M22 13.3V9.9l-5 .1 5 3.3z"></path> </g> <g> <path fill="#1A3179" d="M9.2.1H2.5l6.7 4.6z"></path> </g> <g> <path fill="#1A3179" d="M2.7 14.9h6.5v-4.5z"></path> </g> <g> <g> <path fill="#FFF" d="M9.2 4.7L2.5.1h-.6C1.5.1 1.1.2.8.5l6.6 4.6H5.7L.2 1.2c-.1.1-.1.3-.2.5L4.9 5 0 4.9v1l6.4.1 3.5.1V.2h-.7v4.5z"></path> </g> <g> <path fill="#FFF" d="M12.1 9.1V14.9h.7v-4.4l6.4 4.4h.8c.5 0 .9-.2 1.2-.4l-6.6-4.4h1.6l5.5 3.6c0-.1.1-.2.1-.3L17 10l5-.1v-1l-6.4.1-3.5.1z"></path> </g> <g> <path fill="#FFF" d="M0 8.9v1l5 .1-5 3.3c.1.4.3.8.6 1.1L7.2 10H9l-7.1 4.8h.8l6.4-4.4v4.4h.7V9.1L6.4 9 0 8.9z"></path> </g> <g> <path fill="#FFF" d="M17.1 5L22 1.7c-.1-.5-.4-.9-.7-1.2l-6.6 4.6H13L20.1.2h-.6l-6.7 4.5V.1h-.7V6h3.5l6.4-.1v-1l-4.9.1z"></path> </g> </g> <g> <path fill="#FF2B2D" d="M15.6 6l-3.5.1v-6H9.9v6L6.4 6 0 5.9v3l6.4.1 3.5.1v5.8h2.2V9.1l3.5-.1 6.4-.1v-3z"></path> </g> <g> <path fill="#FF2B2D" d="M5.7 5.1h1.6L.8.5C.5.7.3.9.2 1.2l5.5 3.9z"></path> </g> <g> <path fill="#FF2B2D" d="M13 5.1h1.6L21.2.5c-.3-.2-.7-.4-1.1-.4l-7.1 5z"></path> </g> <g> <path fill="#FF2B2D" d="M14.7 10.1l6.6 4.4c.2-.2.4-.5.5-.8l-5.5-3.6h-1.6z"></path> </g> <g> <path fill="#FF2B2D" d="M7.3 10.1L.7 14.5c.3.3.7.4 1.2.4L9 10.1H7.3z"></path> </g> </g> </symbol> <symbol version="1.1" id="flag-es" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <g> <path fill="#E61B22" d="M0,13c0,1,0.8,1.9,1.9,1.9h18.3c1,0,1.9-0.8,1.9-1.9v-1.8H0V13z"></path> </g> <g> <path fill="#E61B22" d="M20.1,0.1H1.9C0.8,0.1,0,1,0,2v1.8h22V2C22,1,21.2,0.1,20.1,0.1z"></path> </g> <g> <rect y="3.8" fill="#FFCD0C" width="22" height="7.4"></rect> </g> </g> </g> </symbol> <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22 15" id="flag-fr"> <g> <g> <path fill="#193593" d="M1.9.1C.8.1 0 1 0 2v11c0 1 .8 1.9 1.9 1.9h5.4V.1H1.9z"></path> </g> <g> <path fill="#F9F9F9" d="M7.3.1h7.4v14.7H7.3z"></path> </g> <g> <path fill="#FF4032" d="M20.1.1h-5.4v14.7h5.4c1 0 1.9-.8 1.9-1.9V2c0-1-.8-1.9-1.9-1.9z"></path> </g> </g> </symbol> <symbol version="1.1" id="flag-it" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <path fill="#00924E" d="M1.9,0.1C0.8,0.1,0,1,0,2v11c0,1,0.8,1.9,1.9,1.9h5.5V0.1H1.9z"></path> </g> <g> <rect x="7.3" y="0.1" fill="#F9F9F9" width="7.4" height="14.7"></rect> </g> <g> <path fill="#EE2734" d="M20.1,0.1h-5.5v14.7h5.5c1,0,1.9-0.8,1.9-1.9V2C22,1,21.2,0.1,20.1,0.1z"></path> </g> </g> </symbol> <symbol version="1.1" id="flag-nl" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <path fill="#FF4032" d="M20.1,0.1H1.9C0.8,0.1,0,1,0,2v3h22V2C22,1,21.2,0.1,20.1,0.1z"></path> </g> <g> <rect y="5" fill="#FFFFFF" width="22" height="4.9"></rect> </g> <g> <path fill="#193593" d="M0,13c0,1,0.8,1.9,1.9,1.9h18.3c1,0,1.9-0.8,1.9-1.9v-3H0V13z"></path> </g> </g> </symbol> <symbol version="1.1" id="flag-no" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <g> <path fill="#F4253F" d="M11,14.9h9.1c1,0,1.9-0.8,1.9-1.9V9.7H11V14.9z"></path> </g> <g> <path fill="#F4253F" d="M0,13c0,1,0.8,1.9,1.9,1.9h4.8V9.7H0V13z"></path> </g> <g> <path fill="#F4253F" d="M0,2v3.3h6.6V0.1H1.9C0.8,0.1,0,1,0,2z"></path> </g> <g> <path fill="#F4253F" d="M20.1,0.1H11v5.2h11V2C22,1,21.2,0.1,20.1,0.1z"></path> </g> </g> <g> <g> <polygon fill="#FFFFFF" points="6.6,5.3 0,5.3 0,6.6 7.9,6.6 7.9,5.3 7.9,0.1 6.6,0.1 "></polygon> </g> <g> <polygon fill="#FFFFFF" points="9.7,9.7 9.7,14.9 11,14.9 11,9.7 22,9.7 22,8.4 9.7,8.4 "></polygon> </g> <g> <polygon fill="#FFFFFF" points="0,9.7 6.6,9.7 6.6,14.9 7.9,14.9 7.9,9.7 7.9,8.4 0,8.4 "></polygon> </g> <g> <polygon fill="#FFFFFF" points="11,5.3 11,0.1 9.7,0.1 9.7,5.3 9.7,6.6 22,6.6 22,5.3 "></polygon> </g> </g> <g> <polygon fill="#007DBE" points="9.7,6.6 9.7,5.3 9.7,0.1 7.9,0.1 7.9,5.3 7.9,6.6 0,6.6 0,8.4 7.9,8.4 7.9,9.7 7.9,14.9 9.7,14.9 9.7,9.7 9.7,8.4 22,8.4 22,6.6 "></polygon> </g> </g> </symbol> <symbol version="1.1" id="flag-ru" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" enable-background="new 0 0 22 15" xml:space="preserve" viewBox="0 0 22 15"> <g> <g> <path fill="#FF4032" d="M1.9,14.9h18.3c1,0,1.9-0.8,1.9-1.9v-3H0v3C0,14,0.8,14.9,1.9,14.9z"></path> </g> <g> <rect y="5" fill="#233DB8" width="22" height="4.9"></rect> </g> <g> <path fill="#FFFFFF" d="M22,2c0-1-0.8-1.9-1.9-1.9H1.9C0.8,0.1,0,1,0,2v3h22V2z"></path> </g> </g> </symbol></svg>' }} />
    }
    render() {
        const { mobile, landingPagesIntl, aiLandingpagesIntl, t, locale , languageSelectorOptions} = this.props;
        const { open } = this.state;
        const currentLanguage = languageOption(locale, landingPagesIntl ? landingPagesIntl : ( aiLandingpagesIntl ? aiLandingpagesIntl :  languageSelectorOptions));
        const title = (typeof currentLanguage !== 'undefined' ) ? (currentLanguage.metaTitle !== ''  ? currentLanguage.metaTitle : currentLanguage.title) : '' ;
        return (
            <div className="font-90" ref={this.setWrapperRef}>
                {this.flagSprite()}
                { mobile ?
                <div className="mt-4 flex"><SvgIcon  className="mr-2" dangerouslySetInnerHTML={{__html: '<use xlink:href="#flag-' + locale + '"></use>' }}  />
                <LSselect 
                    options={(landingPagesIntl) ? landingPagesIntl : ( aiLandingpagesIntl ? aiLandingpagesIntl : languageSelectorOptions)}
                    className="btn-no no-select-handle"
                    defaultValue={(landingPagesIntl) ? landingPagesIntl.indexOf(currentLanguage) : (aiLandingpagesIntl ? aiLandingpagesIntl.indexOf(currentLanguage) : languageSelectorOptions.indexOf(currentLanguage))}
                    currentLanguage={currentLanguage}
                    onChange={ (event) => this.selectLanguage(event, (landingPagesIntl) ? 'landing' : ( aiLandingpagesIntl ? 'ai_landing': 'default')) }>
                    { this.lpLanguageOptions(locale, ( landingPagesIntl ) ? landingPagesIntl : (aiLandingpagesIntl ? aiLandingpagesIntl : languageSelectorOptions) , mobile)}
                </LSselect>
                </div>
                :
                <LSInner className="flex items-center bor-blue1 bor-thin bor-solid border-radius-default px-2">
                    <img src={(this.props.searchURLBase ? this.props.searchURLBase : '') + "/assets/img/front/icons/language-select-icon.svg"} className="pr-2" style={{width:'32px'}} alt="icon" />
                    <LSInnerA className={this.props.buttonClassName} title={title} href="#" onClick={this.toggle}>
                        <SvgIcon  dangerouslySetInnerHTML={{__html: '<use xlink:href="#flag-' + locale + '"></use>' }}  />
                    </LSInnerA>
                    <LSContainer className={"bg-white bor-blue1 bor-thin bor-solid " +  (open ? '' : 'hidden')}><LStitle>{t('preferred.language')}</LStitle> { this.lpLanguageOptions(locale, ( landingPagesIntl ) ? landingPagesIntl :  languageSelectorOptions, mobile) }</LSContainer>
                </LSInner>
                }
            </div>
        );
    }
}

export const LanguageSelector = compose(
    withTranslator,
    withFosRouter
)(LanguageSelectorComponent);